import React from 'react';

import { functionsData } from 'data/javascript/functions';

import DescriptionEntry from 'components/shared/description-entry';

const JavaScriptFunctions = () => {
  const item = functionsData?.items.find(
    (item) => item.title === 'Functions'
  );

  return <DescriptionEntry entry={item} />;
};

export default JavaScriptFunctions;
